import * as yup from "yup";

const guestValidationSchema = yup.object().shape({
    name: yup
        .string()
        .nullable()
        .typeError('Deve essere in formato testuale'),
    surname: yup
        .string()
        .nullable()
        .typeError('Deve essere in formato testuale'),
    email: yup
        .string()
        .nullable()
        .email('Deve essere un indirizzo email valido'),
});

export default guestValidationSchema;